// src/pages/Shipping.js
import React from 'react';
import { Container } from 'react-bootstrap';

function Shipping() {
  return (
    <Container className="mt-4">
      <h2>Shipping</h2>
      <p>This is the Shipping app page. (Under construction)</p>
    </Container>
  );
}

export default Shipping;
